import React,{Component} from 'react';
import {PostData} from '../service/postData';
import {sendNotification} from '../_notificationSettings/notificationPanel';

//----Include Fragment Pages-----
import HeaderSection from '../websiteFolder/web_fragment/header';
import FooterPage from '../websiteFolder/web_fragment/footer';
//----End Include Fragment Pages-----

export default class aboutUsPagePanel extends Component{
    constructor(props){
        super(props);
        this.state = {
            isLoaded : false,
            isLoggedin : false,
            name:'',
            email:'',
            contact:'',
            message:'',
            errors:{
                name:'',
                email:'',
                contact:'',
                message:'',
            }
        }
    }

    async componentDidMount(){
        this.setState({isLoaded:true});
    }

    handleChange = (event) => {
        event.preventDefault();
        const { name, value } = event.target;
        switch (name) {
            case 'name':
                this.setState({ name: value });
                break;
            case 'email':
                this.setState({ email: value });
                break;
            case 'contact': 
                if (/^\d*$/.test(value)) {
                    if (value.length >= 0 && value.length <= 10) {
                        this.setState({ contact: value });
                    }
                }
            break;
            case 'message': 
                this.setState({message:value}); 
            break;
            default:
            break;
        }
    }

    clickToSubmitEnqury = (event) => {
        event.preventDefault();
        const regex = /^\d{10}$/;
        const isValidEmail = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;
        if(this.state.name == '')
        {
            alert("Name must be 3 characters long!");
        }else if(!(this.state.email && isValidEmail.test(this.state.email))){
            alert("Email-Id is invalid.");
        }else if(!regex.test(this.state.contact)){
            alert('Mobile number is invalid.')
        }else if(this.state.message == '') {
            alert("Please enter your message.");
        }else{
            this.getTouchFormSubmit();
        }
    }

    getTouchFormSubmit()
    {
        const requestData = JSON.stringify({
            name: this.state.name,
            contact: this.state.contact,
            email: this.state.email,
            message: this.state.message,
            pageSubject:'Enquiry From Get In Touch - About Us Page',
        });
        
        PostData(global.sendGetInTouchMail, requestData,'POST').then((result) => {
            if(result.success == true)
            {
                this.setState({name: '',contact: '',email: '',message: ''});
                sendNotification("Success Message 👍","Enquiry mail send successfully.","success");
            }
            else
            {
                sendNotification("Error Message 😓","Some error occured. Please try again.","danger");
                return;
            }
        });
    }

    render(){
        const {errors} = this.state;
        const isDisabled = Object.keys(errors).some(x => errors[x]);
        return(
            <div id="page-wrapper">
                <React.Fragment>
                    <div id="main" className="mainSectionWebsite">
                        <section className="header">
                            <div className="container">
                                <HeaderSection />
                                {/* <!-- Banner --> */}
                                <div className="row inner-banner">
                                    <div className="col-lg-7">
                                        <h1 className="txt-style-8">Simple Yet Powerful Accounting Software, Built for Businesses</h1>
                                        <a className="btn2" href={global.webUrl+"apk/vyavsay.apk"} target='_blank'>Download For Mobile <i className="fas fa-mobile-alt"></i></a>
                                    </div>
                                    
                                    <div className="col-lg-5 img100">
                                        <img src={global.webUrl+"websiteFilesFolder/img/about-banner.png"} alt="" title="" />
                                    </div>
                                </div>
                            </div>
                        </section>
                        
                        <section className="about1">
                            <div className="container">
                                <p><strong>Vyavsay</strong> is a <strong>free business accounting</strong> software specially crafted for <strong>Indian small business owners.</strong> From invoicing and inventory to expense tracking and tax billing, Vyavsay handles it all—so you don’t have to.</p>
                                <p>Designed to simplify your daily operations, Vyavsay reduces the burden of paperwork and helps you focus on what truly matters: growing your business with confidence and clarity.
                                </p>
                            </div>
                        </section>

                        <section className="sec4 sec4B">
                            <div className="container">
                                <div className="row">
                                        <div className="col-lg-12">
                                            <h2 className="txt-title-3">The Right Technology Can Transform Your Business</h2>
                                            <span className="line"></span>
                                        </div>
                                    </div>
                                    <div className="row space1">
                                        <div className="col-lg-4 vys1">
                                            <i className="fas fa-cloud-download-alt"></i>
                                            <p>
                                            Downloads
                                            </p>
                                            <h6>5M+</h6>
                                        </div>
                                        <div className="col-lg-4 vys1">
                                            <img src={global.webUrl+"websiteFilesFolder/img/madeinindia.png"} alt="" title="" />
                                        </div>
                                        <div className="col-lg-4 vys1">
                                            <i className="far fa-star"></i>
                                            <p>
                                            Play Store Ratings
                                            </p>
                                            <h6>4.7 out of 5 Stars</h6>
                                        </div>
                                        
                                    </div>
                            </div>
                        </section>

                        <section className="vyavsay">
                            <div className="container">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <h2 className="txt-title-3">Small and Mid-Sized Enterprise (SME)</h2>
                                        <span className="line"></span>
                                        <p className="txt-style1">
                                        Even today, a majority of small businesses in India still rely on pen-and-paper billing. This not only eats into their valuable time but also increases the chances of costly errors. One small mistake can shake the entire system—simply because there’s no digital safety net. Without the right tools, business owners end up spending more time fixing numbers than growing their business.
                                        </p>
                                        <p className="txt-style1">
                                            That’s where Vyavsay comes in—a smart, simple, and reliable solution designed specifically for small businesses. It’s more than just billing; it’s the digital push every business needs to stay focused, stay efficient, and thrive in today’s competitive world.
                                        </p>
                                        
                                    </div>
                                </div>
                                <div className="row space1">
                                    <div className="col-lg-6" align="center">
                                        <img src={global.webUrl+"websiteFilesFolder/img/100Free.png"} alt="" title="" />
                                    </div>
                                    <div className="col-lg-6 img100" align="center">
                                        <img src={global.webUrl+"websiteFilesFolder/img/aw.png"} alt="" title="" />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-12">
                                        <p className="txt-style2">
                                        “India’s small business sector is the backbone of our economy, yet most SMEs still lack access to modern technology. Vyavsay is built to change that—helping entrepreneurs focus on growth instead of struggling with manual accounting. Our goal is simple: make business accounting easy, efficient, and digital.”
                                        </p>
                                        <h6 className="txt-style-9">— Mr. Neelesh Jain, Founder & Director, Vyavsay</h6>
                                    </div>
                                </div>
                                <div className="row space1">
                                    <div className="col-lg-6" align="center">
                                        <img src={global.webUrl+"websiteFilesFolder/img/language.png"} alt="" title="" />
                                    </div>
                                    <div className="col-lg-6 img100" align="center">
                                        <img src={global.webUrl+"websiteFilesFolder/img/device.png"} alt="" title="" />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-12">
                                        <p className="txt-style2">
                                        Vyavsay is a powerful tax billing and accounting software available on both Android and Desktop. It works offline and gives real-time visibility into your sales, stock, and taxes—making it easy for small businesses around the world to stay compliant, organized, and growth-ready.
                                        </p>
                                        <h6 className="txt-style-9">Vyavsay: Smart Tax Billing for Global Small Businesses</h6>
                                    </div>
                                </div>
                            </div>
                        </section>

                        <section className="sec4 sec4B">
                            <div className="container">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <h2 className="txt-title-3">With the Vyavsay App, Many Possibilities for Small Business Owners</h2>
                                        <span className="line"></span>
                                    </div>
                                </div>
                                <div className="row space1">
                                    <div className="col-lg-6">
                                    <ul className="list1">
                                    <li><i className="fas fa-check-circle"></i> Stay tax-compliant with easy tax billing and invoicing</li>
                                    <li><i className="fas fa-check-circle"></i> Manage all customers, vendors & parties from one place</li>
                                    <li><i className="fas fa-check-circle"></i> Instantly monitor business performance with smart dashboards</li>
                                    <li><i className="fas fa-check-circle"></i> Create, print, and share customized professional invoices</li>
                                    
                                    </ul>
                                    </div>
                                    <div className="col-lg-6">
                                    <ul className="list1">
                                                <li><i className="fas fa-check-circle"></i> Track inventory by batch, expiry, and item units for smarter sales</li>
                                                <li><i className="fas fa-check-circle"></i> Set automated payment reminders to get paid on time</li>
                                                <li><i className="fas fa-check-circle"></i> Work seamlessly even without internet—100% offline-ready</li>
                                                <li><i className="fas fa-check-circle"></i> Enable auto backup to safeguard your data from accidental loss</li>
                                            </ul>
                                    </div>
                                </div>
                            </div>
                        </section>

                        <section className="faq_contact">
                            <div className="container">
                                <div className="row">
                                    <div className="col-lg-6">
                                        <h2 className="txt-style-5">History of vyavsay</h2>
                                        <span className="line line1"></span>
                                        <div id="accordion" className="accordion">
                                            <div className="card mb-0">
                                                <div className="card-header" data-toggle="collapse" href="#collapseOne">
                                                    <a className="card-title">2016</a>
                                                </div>
                                                <div id="collapseOne" className="card-body collapse show" data-parent="#accordion" >
                                                    <p><b>March</b><br/>
                                                    First version of vyavsay app (Mobile).<br/>
                                                    <b>April</b><br/>
                                                    Second version of vyavsay app (Mobile).
                                                    </p>
                                                </div>
                                                <div className="card-header collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapseTwo">
                                                    <a className="card-title">2017</a>
                                                </div>
                                                <div id="collapseTwo" className="card-body collapse" data-parent="#accordion">
                                                    <p><b>June</b><br/>
                                                    vyavsay Launched Desktop App.
                                                    </p>
                                                </div>
                                                <div className="card-header collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapseThree">
                                                    <a className="card-title">2018</a>
                                                </div>
                                                <div id="collapseThree" className="collapse" data-parent="#accordion">
                                                    <div className="card-body">
                                                        <p><b>May</b><br/>
                                                        Funded by renowned Investors of India. <br/>
                                                        <b>July</b><br/>
                                                        vyavsay supports "Auto Sync" feature (BETA version).<br/>
                                                        <b></b><br/>
                                                        vyavsay launched “Hindi” version of Mobile App.<br/>
                                                        <b>November</b><br/>
                                                        Reached 700K+ Downloads</p>
                                                    </div>
                                                </div>
                                                <div className="card-header collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapseThree1">
                                                    <a className="card-title">2019</a>
                                                </div>
                                                <div id="collapseThree1" className="collapse" data-parent="#accordion">
                                                    <div className="card-body">
                                                        <p><b>November</b><br/>
                                                        Reached 700K+ Downloads
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="card-header collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapseThree2">
                                                    <a className="card-title">2020</a>
                                                </div>
                                                <div id="collapseThree2" className="collapse" data-parent="#accordion">
                                                    <div className="card-body">
                                                        <p>
                                                            <b>November</b><br/>
                                                            Reached 800K+ Downloads
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="card-header collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapseThree3">
                                                    <a className="card-title">2020</a>
                                                </div>
                                                <div id="collapseThree3" className="collapse" data-parent="#accordion" >
                                                    <div className="card-body">
                                                        <p>
                                                            <b>November</b><br/>
                                                            Reached 800K+ Downloads
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="get_in_touch">
                                            <h2>Get In Touch</h2>
                                            <form id="get_in_touch">
                                                <div>
                                                    <input className={errors.name.length > 0 && 'errorClass'} onChange={this.handleChange} type="text" placeholder="Name" value={this.state.name} name="name" required style={{color: 'white'}}/>
                                                </div>
                                                <div>
                                                    <input className={errors.email.length > 0 && 'errorClass'} onChange={this.handleChange} type="email" placeholder="Email" value={this.state.email} name="email" required style={{color: 'white'}}/>
                                                </div>
                                                <div>
                                                    <input className={errors.contact.length > 0 && 'errorClass'} onChange={this.handleChange} type="text" placeholder="Phone No." value={this.state.contact} name="contact" required style={{color: 'white'}}/>
                                                </div>
                                                <div>
                                                    <textarea className={errors.message.length > 0 && 'errorClass'} onChange={this.handleChange} placeholder="Message" value={this.state.message} name="message" required style={{color: 'white'}}></textarea>
                                                </div>
                                                <div>
                                                    <button type="button" disabled={isDisabled} onClick={this.clickToSubmitEnqury}>Submit</button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                                <div className="row space1">
                                    <div className="col-lg-12">
                                        <p className="txt-style1">
                                            We’re excited to share that Vyavsay has crossed 5 million installs on the Play Store—trusted by small businesses worldwide for easy tax billing and accounting.
                                        </p>
                                        <br/>
                                        <p className="txt-style1">
                                            Our journey is driven by one goal—to make everyday business management effortless for small enterprises worldwide. We hope the <strong>Vyavsay App</strong> continues to empower more entrepreneurs with smart, reliable, and easy-to-use accounting tools.
                                        </p>
                                    </div>
                                </div>
                                <div className="row space1 vys2">
                                    <div className="col-lg-6">
                                    <a className="btn2" href={global.webUrl+"apk/vyavsay.apk"} target='_blank'>Download For Mobile <i className="fas fa-mobile-alt"></i></a>
                                    </div>
                                </div>
                            </div>
                        </section>
                        {/* Footer Code Here */}
                        <FooterPage />
                    </div>
                </React.Fragment>                
            </div>
        )
    }
}